import axiosClient from "../../../../api/axiosClient";

export const createTicket = async (data, token) => {
  axiosClient.defaults.headers.common["Authorization"] =
    `Bearer ${token}`;

  const response = await axiosClient.post("/tickets", data);
  return response.data;
};
